import axios from '@/libs/api.request'

// ========== 三方支付开关管理 ==========
// Base path: /pay/ability/switches

// GET - 分页查询国家策略
// Params: countryCodes(string[]), device(int: -1=iOS+Android,0=iOS,1=Android), entryPoints(int[]), current, size
export const getStrategyList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/pay/ability/configs'
  })
}

// GET - 获取三方支付开放入口选项
// Response: [{ entrySourceType(1=PAY_ENTRY_POINT页面,2=活动推送规则), entryId, entryName }]
export const getSwitchEntryOptions = () => {
  return axios.request({
    method: 'get',
    url: '/pay/ability/configs/entry-options'
  })
}

// POST - 新增国家策略
// Body: { name, countryCodes[], iosSwitch(bool), androidSwitch(bool),
//   iosRules[{entryConfigs[{entrySourceType,entryId}],crowdIds[]}], androidRules[] }
export const addStrategy = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/pay/ability/configs'
  })
}

// PUT - 编辑国家策略
// Body: { id, ...same as add }
export const editStrategy = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/pay/ability/configs'
  })
}

// GET - 获取全局开关配置
// Response: { iosGlobalSwitch(int: 0=全部开启,1=只开美国,2=全部关闭), androidGlobalSwitch(int: 0=全部开启,1=全部关闭) }
export const getGlobalSwitch = () => {
  return axios.request({
    method: 'get',
    url: '/pay/ability/configs/global'
  })
}

// PUT - 更新全局开关配置
// Body: { iosGlobalSwitch(int), androidGlobalSwitch(int) }
export const saveGlobalSwitch = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/pay/ability/configs/global'
  })
}

// GET - 获取国家策略详情
// Response: { id, name, countryCodes[], countryNames, iosSwitch(bool), androidSwitch(bool),
//   iosRules[{entryConfigs[],entryPointNames,crowdIds[],crowdNames}], androidRules[] }
export const getStrategyInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/pay/ability/configs/' + id
  })
}

// DELETE - 删除国家策略
export const delStrategy = (id) => {
  return axios.request({
    method: 'delete',
    url: '/pay/ability/configs/' + id
  })
}

// GET - 获取已绑定国家策略的国家列表
export const getBoundCountryCodes = () => {
  return axios.request({
    method: 'get',
    url: '/pay/ability/switches/bound/countries'
  })
}

// ========== 支付方式设置管理 ==========
// Base path: /pay/method/settings

// GET - 分页查询国家支付方式配置
// Params: countryCodes(string[]), payMethods(int[]), providers(int[]), current, size
export const getPayConfigList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/pay/method/settings'
  })
}

// POST - 新增国家支付方式配置
// Body: { countryCodes[], iosPayLinkType(int), iosPayMethods[{payMethod,provider,isDefault}], androidPayLinkType, androidPayMethods[] }
export const addPayConfig = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/pay/method/settings'
  })
}

// PUT - 编辑国家支付方式配置
// Body: { id, ...same as add }
export const editPayConfig = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/pay/method/settings'
  })
}

// GET - 获取国家支付方式配置详情
// Response: { id, countryCodes[], countryNames, iosPayLinkType, iosPayMethods[{payMethod,payMethodName,provider,providerName,isDefault}], androidPayLinkType, androidPayMethods[] }
export const getPayConfigInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/pay/method/settings/' + id
  })
}

// DELETE - 删除国家支付方式配置
export const delPayConfig = (id) => {
  return axios.request({
    method: 'delete',
    url: '/pay/method/settings/' + id
  })
}

// GET - 获取已绑定国家支付方式配置的国家列表
export const getBoundCountryCodesConfig = () => {
  return axios.request({
    method: 'get',
    url: '/pay/method/settings/bound/countries'
  })
}

